export default __webpack_public_path__ + "static/media/service-sitting.0e962f02.svg";